import React, { memo } from 'react';

import clsx from 'clsx';

import { TableRow, makeStyles } from '@gogame/components';
import { DateValueFormatter, NumberValueFormatter } from '@gogame/intl-ts';

import CohortsCell from './CohortsCell';
import MetricValueFormatter from './components/MetricValueFormatter';

const useStyles = makeStyles(
  {
    root: {},
    regsCell: {
      minWidth: 70,
    },
    numberCell: {
      minWidth: 40,
    },
    bold: {
      '& th, td': {
        fontWeight: 'bold',
      },
    },
  },
  { name: 'CohortsRow' }
);

const CohortsRow = memo(
  ({
    subHeader,
    subHeaderTitle,
    regDate,
    regs,
    data,
    dimensionType,
    spent,
    actual,
    row,
  }) => {
    const classes = useStyles();

    return (
      <TableRow
        borderBottom
        className={
          (classes.root,
          {
            [classes.bold]: subHeader,
          })
        }
      >
        <CohortsCell
          column={0}
          className={clsx(classes.regsCell)}
          align={'left'}
          borderRight={true}
          row={row}
        >
          {regDate ? (
            <DateValueFormatter
              value={regDate}
              template={'L'}
              timeZone={'utc'}
            />
          ) : subHeaderTitle ? (
            subHeaderTitle
          ) : null}
        </CohortsCell>

        <CohortsCell
          column={1}
          className={clsx(classes.regsCell)}
          align={'right'}
          borderRight={true}
          row={row}
        >
          <NumberValueFormatter.Decimal value={regs} />
        </CohortsCell>
        {spent !== undefined ? (
          <CohortsCell
            column={2}
            className={clsx(classes.regsCell)}
            align={'right'}
            borderRight={true}
            row={row}
            variant={subHeader ? 'header' : undefined}
          >
            <NumberValueFormatter.Currency value={spent} />
          </CohortsCell>
        ) : null}
        {data.map(({ value, intensity }, i) => {
          return (
            <CohortsCell
              column={3 + i}
              key={i}
              className={clsx(classes.numberCell)}
              align={'right'}
              borderRight={true}
              intensity={subHeader ? undefined : intensity}
              row={row}
            >
              {value ? (
                <MetricValueFormatter value={value} type={dimensionType} />
              ) : (
                ''
              )}
            </CohortsCell>
          );
        })}
        {actual !== undefined ? (
          <CohortsCell
            column={4 + data.length}
            className={clsx(classes.numberCell)}
            align={'right'}
            borderRight={true}
            row={row}
          >
            <MetricValueFormatter value={actual} type={dimensionType} />
          </CohortsCell>
        ) : null}
      </TableRow>
    );
  }
);

export default CohortsRow;
